module.exports = __webpack_public_path__ + "img/how_does_it_work.fae5d163.png";